export enum CustomErrorType {
    ComparisonUserProfileNotFound = "ComparisonUserProfileNotFound",
    ComparisonCelebrityProfileNotFound = "ComparisonCelebritysProfileNotFound",
}